import { adminCable } from "src/admin_cable";
import { Subscription } from "@rails/actioncable";

type UpdateCandidate<T> = { [P in keyof T]?: UpdateCandidate<T[P]> };

export type AdminPreferences = {
  "dashboard": {
    "columns": number;
  };
};

export type PreferenceUpdate = (ap: AdminPreferences) => void;

export class AdminPreferencesTracker {
  private static _instance?: AdminPreferencesTracker;

  preferences?: AdminPreferences;
  broadcastTargets: Array<WeakRef<PreferenceUpdate>> = [];
  cableSubscription?: Subscription;

  static instance() : AdminPreferencesTracker {
    AdminPreferencesTracker._instance ??= new AdminPreferencesTracker();
    return AdminPreferencesTracker._instance;
  }

  update(data: UpdateCandidate<AdminPreferences>) {
    this.ensureSubscribed().perform("change_preferences", data);
  }

  register(callback: PreferenceUpdate) {
    this.ensureSubscribed();
    this.broadcastTargets.push(new WeakRef(callback));

    if (this.preferences) {
      callback(this.preferences);
    }
  }

  ensureSubscribed() : Subscription {
    return this.cableSubscription ??= adminCable().subscriptions.create("AdminPreferencesChannel", {
      received: (data: AdminPreferences) => {
        this.preferences = data;

        this.broadcastTargets?.forEach((ref) => {
          ref.deref()?.(data);
        })
      },
    });
  }
}
